import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GhiseulUnicSettingsModule } from './ghiseul-unic-settings/ghiseul-unic-settings.module';
import { CereriModule } from './cereri/cereri.module';
import { ProgramariModule } from './programari/programari.module';
import { ProgramariViewModule } from './programari-view/programari-view.module';
import { NotificariModule } from './notificari/notificari.module';
import { BorderouriAutomateModule } from './borderouri-automate/borderouri-automate.module';
import { DashboardProgramariModule } from './dashboard-programari/dashboard-programari.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        GhiseulUnicSettingsModule,
        CereriModule,
        ProgramariModule,
        ProgramariViewModule,
        NotificariModule,
        BorderouriAutomateModule,
        DashboardProgramariModule,
    ]
})
export class GhiseulUnicModule { }
